<template>
  <div class="header">
    <h1>{{ $t("gold") }}91</h1>
    <nav class="navbar">
      <ul>
        <li
          tag="li"
          @click="redirectTo('/')"
          :class="{ isActive: selectedType === '/' }"
        >
          <div class="header-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="40"
              height="40"
              viewBox="0 0 40 40"
            >
              <defs>
                <clipPath id="b"><rect width="40" height="40" /></clipPath>
              </defs>
              <g id="a" clip-path="url(#b)">
                <path
                  d="M.73,24a.721.721,0,0,1-.671-.945l1.947-6.22a.708.708,0,0,1,.671-.5h3.18l1.79-5.718a.707.707,0,0,1,.671-.5h7.387a.707.707,0,0,1,.671.5l1.79,5.718h3.18a.707.707,0,0,1,.671.5l1.948,6.22a.721.721,0,0,1-.671.945Zm12.25-1.447h9.347L20.833,17.78H14.474Zm-11.282,0h9.347L9.551,17.78H3.192Zm10.315-1.642.98-3.13h-1.96ZM7.339,16.333h9.347l-1.494-4.773H8.833Zm13.977-3.576a.735.735,0,0,1,.192-1l1.6-1.105a.694.694,0,0,1,.979.2.736.736,0,0,1-.193,1l-1.6,1.105a.689.689,0,0,1-.393.123A.7.7,0,0,1,21.316,12.758Zm-19.4.2-1.6-1.105a.736.736,0,0,1-.193-1,.693.693,0,0,1,.978-.2l1.6,1.105a.735.735,0,0,1,.193,1,.7.7,0,0,1-.586.32A.689.689,0,0,1,1.917,12.955Zm15.925-6A.737.737,0,0,1,17.7,5.942l1.166-1.581a.694.694,0,0,1,.988-.14A.735.735,0,0,1,20,5.234L18.829,6.816a.7.7,0,0,1-.563.287A.69.69,0,0,1,17.842,6.956Zm-12.46-.14L4.215,5.234A.736.736,0,0,1,4.352,4.22a.694.694,0,0,1,.988.14L6.506,5.942a.737.737,0,0,1-.137,1.014.69.69,0,0,1-.425.147A.7.7,0,0,1,5.382,6.816Zm7.456-1.528a.735.735,0,0,1-.706-.74l.014-2.965a.694.694,0,0,1,.716-.694.736.736,0,0,1,.707.74l-.014,2.966a.693.693,0,0,1-.694.694Z"
                  transform="translate(8 8)"
                  fill="#fff"
                />
              </g>
            </svg>
          </div>
          {{ $t("locker") }}
        </li>
        <li
          tag="li"
          @click="redirectTo('/buy-gold')"
          :class="{ isActive: selectedType === '/buy-gold' }"
        >
          <div class="header-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="40"
              height="40"
              viewBox="0 0 40 40"
            >
              <defs>
                <clipPath id="b"><rect width="40" height="40" /></clipPath>
              </defs>
              <g id="a" clip-path="url(#b)">
                <path
                  d="M.73,24a.721.721,0,0,1-.671-.945l1.947-6.22a.707.707,0,0,1,.671-.5H5.857l1.79-5.718a.707.707,0,0,1,.671-.5h7.387a.707.707,0,0,1,.671.5l1.79,5.718h3.179a.708.708,0,0,1,.672.5l1.947,6.22a.721.721,0,0,1-.672.945Zm12.249-1.447h9.348L20.833,17.78H14.474Zm-11.282,0h9.348L9.551,17.78H3.192Zm10.315-1.642.98-3.131H11.032ZM7.339,16.333h9.348L15.192,11.56H8.833ZM1.917,12.955l-1.6-1.106a.735.735,0,0,1-.193-1,.694.694,0,0,1,.979-.2l1.6,1.106a.735.735,0,0,1,.193,1,.7.7,0,0,1-.586.32A.69.69,0,0,1,1.917,12.955ZM17.859,7.384V5.057H15.651a.931.931,0,0,1,0-1.861h2.208V.931a.907.907,0,1,1,1.813,0V3.2H21.94a.931.931,0,0,1,0,1.861H19.672V7.384a.907.907,0,1,1-1.813,0ZM5.382,6.816,4.215,5.234A.736.736,0,0,1,4.352,4.22a.694.694,0,0,1,.988.14L6.506,5.942A.736.736,0,0,1,6.37,6.956a.693.693,0,0,1-.988-.14Z"
                  transform="translate(8 8)"
                  fill="#fff"
                />
              </g>
            </svg>
          </div>
          {{ $t("buy") }}
        </li>
        <li
          tag="li"
          @click="redirectTo('/sell-gold')"
          :class="{ isActive: selectedType === '/sell-gold' }"
        >
          <div class="header-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="40"
              height="40"
              viewBox="0 0 40 40"
            >
              <defs>
                <clipPath id="b"><rect width="40" height="40" /></clipPath>
              </defs>
              <g id="a" clip-path="url(#b)">
                <path
                  d="M.73,24a.822.822,0,0,1-.671-1.09l1.947-7.175a.729.729,0,0,1,.671-.58h3.18l1.79-6.6a.728.728,0,0,1,.671-.579h7.387a.728.728,0,0,1,.671.579l1.79,6.6h3.179a.729.729,0,0,1,.671.58l1.948,7.175A.822.822,0,0,1,23.294,24ZM12.98,22.33h9.348l-1.494-5.506H14.474ZM1.7,22.33h9.348L9.551,16.824H3.192Zm10.315-1.894.98-3.612H11.032ZM7.339,15.155h9.348L15.192,9.649H8.833Zm-5.422-3.9L.312,9.982A.933.933,0,0,1,.12,8.824.641.641,0,0,1,1.1,8.6L2.7,9.872A.934.934,0,0,1,2.9,11.03a.682.682,0,0,1-.586.37A.628.628,0,0,1,1.917,11.258ZM5.381,4.176,4.215,2.351a.94.94,0,0,1,.137-1.169.636.636,0,0,1,.988.162L6.506,3.168a.94.94,0,0,1-.137,1.169.634.634,0,0,1-.425.169A.673.673,0,0,1,5.381,4.176ZM15.651,2.147a1,1,0,0,1-.907-1.073A1,1,0,0,1,15.651,0H21.94a1,1,0,0,1,.907,1.073,1,1,0,0,1-.907,1.073Z"
                  transform="translate(8 8)"
                  fill="#fff"
                />
              </g>
            </svg>
          </div>
          {{ $t("sell") }}
        </li>
        <li
          tag="li"
          @click="redirectTo('/products')"
          :class="{ isActive: selectedType === '/products' }"
        >
          <div class="header-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="40"
              height="40"
              viewBox="0 0 40 40"
            >
              <defs>
                <clipPath id="b"><rect width="40" height="40" /></clipPath>
              </defs>
              <g id="a" clip-path="url(#b)">
                <g transform="translate(5 -68.521)">
                  <g transform="translate(20.556 92.9)">
                    <path
                      d="M325.4,304.4a3.251,3.251,0,1,0,3.251,3.251A3.254,3.254,0,0,0,325.4,304.4Zm0,4.876a1.625,1.625,0,1,1,1.625-1.625A1.627,1.627,0,0,1,325.4,309.279Z"
                      transform="translate(-322.151 -304.403)"
                      fill="#fff"
                    />
                  </g>
                  <g transform="translate(6.269 92.9)">
                    <path
                      d="M104.9,304.4a3.251,3.251,0,1,0,3.251,3.251A3.254,3.254,0,0,0,104.9,304.4Zm0,4.876a1.625,1.625,0,1,1,1.625-1.625A1.627,1.627,0,0,1,104.9,309.279Z"
                      transform="translate(-101.647 -304.403)"
                      fill="#fff"
                    />
                  </g>
                  <g transform="translate(20.989 80.146)">
                    <path
                      d="M335.762,111.238a.813.813,0,0,0-.726-.448h-4.28v1.625h3.779l2.213,4.4,1.452-.73Z"
                      transform="translate(-330.756 -110.79)"
                      fill="#fff"
                    />
                  </g>
                  <g transform="translate(13.29 95.365)">
                    <g transform="translate(0 0)">
                      <rect width="6.149" height="1.625" fill="#fff" />
                    </g>
                  </g>
                  <g transform="translate(2.303 95.365)">
                    <g transform="translate(0 0)">
                      <path
                        d="M49.345,353.345H46.528a.813.813,0,1,0,0,1.625h2.817a.813.813,0,1,0,0-1.625Z"
                        transform="translate(-45.715 -353.345)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                  <g transform="translate(2.303 78.521)">
                    <g transform="translate(0 0)">
                      <path
                        d="M73.328,89.117l-1.893-2.458a.958.958,0,0,0-.76-.375H63.681V79.491a.966.966,0,0,0-.962-.97H46.677a.97.97,0,0,0,0,1.941H61.756v6.793a.966.966,0,0,0,.962.97H70.2l1.4,1.82v5H68.943a.97.97,0,0,0,0,1.941h3.625a.966.966,0,0,0,.962-.97V89.713A.977.977,0,0,0,73.328,89.117Z"
                        transform="translate(-45.715 -78.521)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                  <g transform="translate(1.327 90.042)">
                    <g transform="translate(0 0)">
                      <path
                        d="M30.9,271.6H27.166a.813.813,0,0,0,0,1.625H30.9a.813.813,0,0,0,0-1.625Z"
                        transform="translate(-26.353 -271.597)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                  <g transform="translate(0 86.255)">
                    <path
                      d="M7.747,208.134H.813a.813.813,0,0,0,0,1.625H7.747a.813.813,0,0,0,0-1.625Z"
                      transform="translate(0 -208.134)"
                      fill="#fff"
                    />
                  </g>
                  <g transform="translate(1.327 82.468)">
                    <g transform="translate(0 0)">
                      <path
                        d="M34.1,144.672H27.166a.813.813,0,1,0,0,1.625H34.1a.813.813,0,1,0,0-1.625Z"
                        transform="translate(-26.353 -144.672)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          {{ $t("goldproduct") }}
        </li>
        <li
          tag="li"
          @click="redirectTo('/my-orders')"
          :class="{ isActive: selectedType === '/my-orders' }"
        >
          <div class="header-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="40"
              height="40"
              viewBox="0 0 40 40"
            >
              <defs>
                <clipPath id="b"><rect width="40" height="40" /></clipPath>
              </defs>
              <g id="a" clip-path="url(#b)">
                <g transform="translate(5 -68.521)">
                  <g transform="translate(20.556 92.9)">
                    <path
                      d="M325.4,304.4a3.251,3.251,0,1,0,3.251,3.251A3.254,3.254,0,0,0,325.4,304.4Zm0,4.876a1.625,1.625,0,1,1,1.625-1.625A1.627,1.627,0,0,1,325.4,309.279Z"
                      transform="translate(-322.151 -304.403)"
                      fill="#fff"
                    />
                  </g>
                  <g transform="translate(6.269 92.9)">
                    <path
                      d="M104.9,304.4a3.251,3.251,0,1,0,3.251,3.251A3.254,3.254,0,0,0,104.9,304.4Zm0,4.876a1.625,1.625,0,1,1,1.625-1.625A1.627,1.627,0,0,1,104.9,309.279Z"
                      transform="translate(-101.647 -304.403)"
                      fill="#fff"
                    />
                  </g>
                  <g transform="translate(20.989 80.146)">
                    <path
                      d="M335.762,111.238a.813.813,0,0,0-.726-.448h-4.28v1.625h3.779l2.213,4.4,1.452-.73Z"
                      transform="translate(-330.756 -110.79)"
                      fill="#fff"
                    />
                  </g>
                  <g transform="translate(13.29 95.365)">
                    <g transform="translate(0 0)">
                      <rect width="6.149" height="1.625" fill="#fff" />
                    </g>
                  </g>
                  <g transform="translate(2.303 95.365)">
                    <g transform="translate(0 0)">
                      <path
                        d="M49.345,353.345H46.528a.813.813,0,1,0,0,1.625h2.817a.813.813,0,1,0,0-1.625Z"
                        transform="translate(-45.715 -353.345)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                  <g transform="translate(2.303 78.521)">
                    <g transform="translate(0 0)">
                      <path
                        d="M73.328,89.117l-1.893-2.458a.958.958,0,0,0-.76-.375H63.681V79.491a.966.966,0,0,0-.962-.97H46.677a.97.97,0,0,0,0,1.941H61.756v6.793a.966.966,0,0,0,.962.97H70.2l1.4,1.82v5H68.943a.97.97,0,0,0,0,1.941h3.625a.966.966,0,0,0,.962-.97V89.713A.977.977,0,0,0,73.328,89.117Z"
                        transform="translate(-45.715 -78.521)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                  <g transform="translate(1.327 90.042)">
                    <g transform="translate(0 0)">
                      <path
                        d="M30.9,271.6H27.166a.813.813,0,0,0,0,1.625H30.9a.813.813,0,0,0,0-1.625Z"
                        transform="translate(-26.353 -271.597)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                  <g transform="translate(0 86.255)">
                    <path
                      d="M7.747,208.134H.813a.813.813,0,0,0,0,1.625H7.747a.813.813,0,0,0,0-1.625Z"
                      transform="translate(0 -208.134)"
                      fill="#fff"
                    />
                  </g>
                  <g transform="translate(1.327 82.468)">
                    <g transform="translate(0 0)">
                      <path
                        d="M34.1,144.672H27.166a.813.813,0,1,0,0,1.625H34.1a.813.813,0,1,0,0-1.625Z"
                        transform="translate(-26.353 -144.672)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          {{ $t("myorders") }}
        </li>
        <li
          tag="li"
          @click="redirectTo('/gift-wrapper')"
          :class="{ isActive: selectedType === '/gift-wrapper' }"
        >
          <div class="header-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="40"
              height="40"
              viewBox="0 0 40 40"
            >
              <defs>
                <clipPath id="b"><rect width="40" height="40" /></clipPath>
              </defs>
              <g id="a" clip-path="url(#b)">
                <g transform="translate(9 8)">
                  <g transform="translate(0 0)">
                    <path
                      d="M52.469,8.378,50.1,7.517a2.864,2.864,0,1,0-3.719-4.354L44.752,4.606l-.323-2.165A2.865,2.865,0,1,0,38.78,3.4l-2.23-.812A2.12,2.12,0,0,0,33.836,3.85L32.871,6.5a.706.706,0,0,0,.422.9l11.032,4.015H33.672a.706.706,0,0,0-.706.706v9.882a2.12,2.12,0,0,0,2.118,2.118H49.2a2.12,2.12,0,0,0,2.118-2.118V13.969l.546.2a.706.706,0,0,0,.9-.422l.966-2.653A2.12,2.12,0,0,0,52.469,8.378ZM40.025,22.716H35.084a.707.707,0,0,1-.706-.706V12.835h5.647Zm2.823,0H41.436V12.835h1.412Zm4.471-18.5a1.452,1.452,0,1,1,.466,2.453l-2.3-.835ZM40.739,1.694a1.452,1.452,0,0,1,2.294.957l.362,2.424L41.1,4.24A1.459,1.459,0,0,1,40.739,1.694Zm.333,7.043L34.439,6.322l.724-1.99a.707.707,0,0,1,.9-.422l5.969,2.173Zm2.653.966L42.4,9.219l.966-2.653,1.327.483Zm6.182,12.308a.707.707,0,0,1-.706.706H44.26V12.835H48.2l1.7.62v8.556Zm2.5-11.4-.724,1.99-6.633-2.414.966-2.653L51.986,9.7A.707.707,0,0,1,52.408,10.609Z"
                      transform="translate(-32.828 0.001)"
                      fill="#d8aa00"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          {{ $t("gift") }}
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { toaster } from "../utils/helper";
export default {
  data() {
    return {
      selectedType: this.$route.path
    };
  },

  computed: {
    ...mapGetters(["user", "isUserAuthorized"])
  },

  methods: {
    redirectTo(type) {
      if (type === "/") {
        this.selectedType = type;
        this.$router.push(type);
        return;
      }
      if (!this.isUserAuthorized) {
        toaster(this, this.$t("notauthorised"), "top-left", 2000);
        return;
      }
      if (type === "/sell-gold" && !this.user.total_gold_amount) {
        toaster(this, this.$t("enoughgoldtosell"), "top-left", 2000);
        return;
      }
      if (type === "/gift-wrapper" && !this.user.total_gold_amount) {
        toaster(this, this.$t("enoughgold"), "top-left", 2000);
        return;
      }
      const { is_registered, user_purse_details } = this.user;
      if (!is_registered) {
        toaster(this, this.$t("notregistered"), "top-left", 3000);
        this.$router.push("/registration");
        return;
      }
      this.selectedType = type;
      this.$router.push(type);
    },
    scrollLeftHeder() {
      const activeNavlist = document.getElementsByClassName("isActive");
      const scrollnavlist = document.querySelector(".navbar ul");
      scrollnavlist.scrollTo({
        top: 0,
        left: activeNavlist[0].offsetLeft - 75,
        behavior: "smooth"
      });
    }
  },

  mounted() {
    this.scrollLeftHeder();
  }
};
</script>
